<template>
  <modal @close="$emit('close')">
    <template #body>
      <div class="modal-write">
        <div class="modal-write__form">
          <div class="modal-write__title">Нужны автозапчасти?</div>
          <div class="modal-write__info">
            Оставь VIN-запрос, получи цены и сроки от нашего партнёра.
            Детали поставляются только от официальных дистрибьюторов и по привлекательным ценам.
          </div>

          <form @submit.prevent="send" novalidate>
            <div class="modal-write__inputs-row">
              <Input placeholder="Имя" type="text" class="input input-full" v-model="name" />
              <Input placeholder="Номер телефона" type="tel" class="input input-full" v-model="phone" />
            </div>
            <div class="modal-write__inputs-row">
              <Input placeholder="Марка автомобиля" type="text" class="input input-full" v-model="carBrand" />
              <Input placeholder="Модель автомобиля" type="text" class="input input-full" v-model="carModel" />
            </div>
            <div class="modal-write__inputs-row">
              <Input placeholder="Год выпуска" type="number" class="input input-full" v-model="carYear" />
              <Input placeholder="VIN / № кузова" type="text" class="input input-full" v-model="vin" />
            </div>
            <div class="modal-write__input-box">
              <Textarea placeholder="Список запчастей" class="input input-full" v-model="partsList" />
            </div>

            <button type="submit" class="full-dark-btn vin-submit" :disabled="!agreed || sending">
              {{ sending ? 'Отправка…' : 'Отправить' }}
            </button>

            <Checkbox
              label="Я согласен с <a href='/privacy'>обработкой персональных данных</a>"
              :isCheck="agreed"
              name="agreement_vin_request"
              @change="agreed = $event"
            />

            <p v-if="error" class="vin-error">{{ error }}</p>
            <LoginHint />
          </form>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import LoginHint from "~/components/UI/LoginHint.vue";
import modal from '~/components/UI/Modal.vue'
import Input from '~/components/UI/inputs/Input.vue'
import Textarea from '~/components/UI/inputs/Textarea.vue'
import Checkbox from '~/components/UI/btn/Checkbox.vue'
import { VinRequest } from '~/api/VinRequest'
import { UserService } from '~/services/UserService'

const emit = defineEmits(['close'])

const name = ref('')
const phone = ref('')
const carBrand = ref('')
const carModel = ref('')
const carYear = ref('')
const vin = ref('')
const partsList = ref('')
const agreed = ref(false)
const sending = ref(false)
const error = ref('')

const { show: showToast } = useToast()

watch(phone, (val) => {
  let digits = val.replace(/\D/g, '')
  if (digits.startsWith('7') || digits.startsWith('8')) digits = digits.slice(1)
  digits = digits.slice(0, 10)
  let masked = '+7'
  if (digits.length > 0) masked += ' ' + digits.slice(0, 3)
  if (digits.length > 3) masked += ' ' + digits.slice(3, 6)
  if (digits.length > 6) masked += '-' + digits.slice(6, 8)
  if (digits.length > 8) masked += '-' + digits.slice(8, 10)
  if (phone.value !== masked) phone.value = masked
})

async function send() {
  error.value = ''
  if (!name.value.trim() || !phone.value.trim() || !carBrand.value.trim() ||
      !carModel.value.trim() || !carYear.value || !vin.value.trim() || !partsList.value.trim()) {
    error.value = 'Заполните все поля.'
    return
  }
  if (!agreed.value) {
    error.value = 'Подтвердите согласие на обработку персональных данных.'
    return
  }

  sending.value = true
  try {
    await VinRequest.submit({
      name: name.value,
      phone: phone.value,
      carBrand: carBrand.value,
      carModel: carModel.value,
      carYear: carYear.value,
      vin: vin.value,
      partsList: partsList.value,
    })

    const user = await UserService.getInstance().getCurrent()
    emit('close')
    showToast('Запрос принят. Мы свяжемся с вами в ближайшее время.')
    if (!user) {
      setTimeout(() => showToast('Авторизуйтесь, чтобы отслеживать статус запроса.'), 400)
    }
  } catch {
    error.value = 'Произошла ошибка. Попробуйте ещё раз.'
  } finally {
    sending.value = false
  }
}
</script>

<style scoped lang="scss">
.vin-submit {
  margin-top: 0.4rem;
}

.vin-error {
  margin-top: 1.2rem;
  font-size: 1.4rem;
  color: #c62828;
}
</style>
